import videojs from 'video.js';

class LabelImageComponent extends videojs.getComponent('Component') {
	constructor(player, options) {
		super(player, options);
		this.el().href = options.href;
		this.breakPoints = Object.keys(options.images)
			.filter((key) => key.match(/^\d+$/))
			.map(parseInt)
			.sort((a, b) => b - a);
		this.applyStyles();
		player.on('playerresize', this.applyStyles.bind(this));
	}

	createEl() {
		return videojs.dom.createEl('a', {className: 'vjs-label-image', target: '_blank'});
	}

	applyStyles() {
		let imageData = this.options_.images['base'];
		const playerWidth = this.player().currentWidth();
		for (const breakPoint of this.breakPoints) {
			if (breakPoint >= playerWidth) {
				imageData = this.options_.images[breakPoint.toString()];
				break;
			}
		}
		for (const key of Object.keys(imageData)) {
			this.el().style[key] = imageData[key];
		}
	}
}

videojs.registerComponent('LabelImageComponent', LabelImageComponent);
